import { useGetOrganizationsQuery } from "../gateways/cms/organizationApi";

// [コンテンツ編集] 請求情報 配信先指定

export interface Props {
    value?: string | number;
    disabled?: boolean;
    required?: boolean;
    exclude?: number[];
    onChange?: (value: string) => void;
}

/**
 * 組織のセレクトボックス（全ての組織）
 */
export function SelectOrganization({ value, disabled, required, exclude, onChange = () => {} }: Props) {
    const allOrganizations = useGetOrganizationsQuery();
    const organizations = allOrganizations.data?.data?.filter((o) => !exclude?.includes(o.id));

    let message = 'テナントデータ取得中';
    if (allOrganizations.isFetching) {
        message = 'テナントデータ取得中';
    }
    else{
        message = "未選択";
    }

    return (
        <select value={value} required={required} disabled={disabled} onChange={(e) => onChange(e.target.value)}>
            <option value="">{message}</option>
            {organizations?.map((organization) => (
                <option key={organization.id} value={organization.id}>
                    {organization.name}
                </option>
            ))}
        </select>
    );
}
